import { fadeInHeightExpandTransition as a } from "../../../_styles/transitions/fade-in-height-expand.cssr.js";
import { iconSwitchTransition as l } from "../../../_styles/transitions/icon-switch.cssr.js";
import { cB as e, c as n, cM as o, cE as r, cNotM as t } from "../../../_utils/cssr/index.js";
const i = l(), b = e("tree", `
 font-size: var(--n-font-size);
 outline: none;
`, [n("ul, li", `
 margin: 0;
 padding: 0;
 list-style: none;
 `), n(">", [e("tree-node", [n("&:first-child", "margin-top: 0;")])]), e("tree-motion-wrapper", [o("expand", [a({
  duration: "0.2s"
})]), o("collapse", [a({
  duration: "0.2s",
  reverse: !0
})])]), e("tree-node-wrapper", `
 box-sizing: border-box;
 padding: var(--n-node-wrapper-padding);
 `), e("tree-node", `
 position: relative;
 display: flex;
 border-radius: var(--n-node-border-radius);
 transition: background-color .3s var(--n-bezier);
 `, [o("highlight", [e("tree-node-content", [r("text", "border-bottom-color: var(--n-node-text-color-disabled);")])]), o("disabled", [e("tree-node-content", `
 color: var(--n-node-text-color-disabled);
 cursor: not-allowed;
 `)]), t("disabled", [o("clickable", [e("tree-node-content", `
 cursor: pointer;
 `)])])]), o("block-node", [e("tree-node-content", `
 flex: 1;
 min-width: 0;
 `)]), t("block-line", [e("tree-node", [t("disabled", [e("tree-node-content", [n("&:hover", "background: var(--n-node-color-hover);")]), o("selectable", [e("tree-node-content", [n("&:active", "background: var(--n-node-color-pressed);")])]), o("pending", [e("tree-node-content", `
 background: var(--n-node-color-hover);
 `)]), o("selected", [e("tree-node-content", "background: var(--n-node-color-active);")])]), o("selected", [e("tree-node-content", "background: var(--n-node-color-active);")])])]), o("block-line", [e("tree-node", [t("disabled", [n("&:hover", "background: var(--n-node-color-hover);"), o("pending", `
 background: var(--n-node-color-hover);
 `), o("selectable", [t("selected", [n("&:active", "background: var(--n-node-color-pressed);")])]), o("selected", "background: var(--n-node-color-active);")]), o("selected", "background: var(--n-node-color-active);"), o("disabled", `
 cursor: not-allowed;
 `)])]), e("tree-node-indent", `
 flex-grow: 0;
 flex-shrink: 0;
 `, [o("show-line", "position: relative", [n("&::before", `
 position: absolute;
 left: 50%;
 border-left: 1px solid var(--n-line-color);
 transition: border-color .3s var(--n-bezier);
 transform: translate(-50%);
 content: "";
 top: var(--n-line-offset-top);
 bottom: var(--n-line-offset-bottom);
 `), o("last-child", [n("&::before", `
 bottom: 50%;
 `)]), o("is-leaf", [n("&::after", `
 position: absolute;
 content: "";
 left: calc(50% + 0.5px);
 right: 0;
 bottom: 50%;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-line-color);
 `)])]), t("show-line", "height: 0;")]), e("tree-node-switcher", `
 cursor: pointer;
 display: inline-flex;
 flex-shrink: 0;
 height: var(--n-node-content-height);
 align-items: center;
 justify-content: center;
 transition: transform .15s var(--n-bezier);
 vertical-align: bottom;
 `, [r("icon", `
 position: relative;
 height: 14px;
 width: 14px;
 display: flex;
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 font-size: 14px;
 `, [e("icon", [i]), e("base-loading", `
 color: var(--n-loading-color);
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 `, [i]), e("base-icon", [i])]), o("hide", "visibility: hidden;"), o("expanded", "transform: rotate(90deg);")]), e("tree-node-checkbox", `
 display: inline-flex;
 height: var(--n-node-content-height);
 vertical-align: bottom;
 align-items: center;
 justify-content: center;
 `), e("tree-node-content", `
 user-select: none;
 position: relative;
 display: inline-flex;
 align-items: center;
 min-height: var(--n-node-content-height);
 box-sizing: border-box;
 line-height: var(--n-line-height);
 vertical-align: bottom;
 padding: 0 6px 0 4px;
 cursor: default;
 border-radius: var(--n-node-border-radius);
 color: var(--n-node-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [n("&:last-child", "margin-bottom: 0;"), r("prefix", `
 display: inline-flex;
 margin-right: 8px;
 `), r("text", `
 border-bottom: 1px solid #0000;
 transition: border-color .3s var(--n-bezier);
 flex-grow: 1;
 max-width: 100%;
 `), r("suffix", `
 display: inline-flex;
 `)]), r("empty", "margin: auto;")]);
export {
  b as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/styles/index.cssr.js
// module id = 1763
// module chunks = 67